import { genericPage, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
///tot-cataleg/[series|entreteniment|podcasts|actualitat|esports|sx3|cultura|pellicules|documentals|eva|cuines]
const path = ['web', process.env.FOLDER_LAYOUTS, 'tot-cataleg', 'tipus'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
